var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "invoiceDetails" },
    [
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.changeCurrency,
              modalData: _vm.modalData,
              validate: "cityCurrency",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (slotProps) {
                    return _c(
                      "div",
                      {},
                      [
                        _c("currencySelect", {
                          attrs: {
                            updateCurrency: slotProps.updateCurrency,
                            updateModalData: slotProps.updateModalData,
                            countries: _vm.countriesCurrencies,
                            curencies: _vm.currencies,
                          },
                        }),
                      ],
                      1
                    )
                  },
                },
              ],
              null,
              false,
              571911550
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.modalComments
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalComments,
                expression: "modalComments",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.saveComment,
              modalData: _vm.modalComments,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (slotProps) {
                    return _c("div", {}, [
                      _vm.modalComments.detail.comments &&
                      _vm.modalComments.detail.comments.length
                        ? _c(
                            "div",
                            _vm._l(
                              _vm.modalComments.detail.comments,
                              function (comment) {
                                return _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-left modal_comment_block",
                                  },
                                  [
                                    _c("p", [_vm._v(_vm._s(comment.text))]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(comment.user_name) +
                                          " (" +
                                          _vm._s(_vm.printDate(comment.date)) +
                                          ")"
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.modalComments.new_comment,
                              expression: "modalComments.new_comment",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            placeholder: "Ваш комментарий",
                          },
                          domProps: { value: _vm.modalComments.new_comment },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.modalComments,
                                "new_comment",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ])
                  },
                },
              ],
              null,
              false,
              577555747
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("table", { staticClass: "table table-sm table-hover" }, [
        _c("thead", [
          _c(
            "tr",
            [
              _c("th", { attrs: { width: "50px" } }, [_vm._v("№")]),
              _vm._v(" "),
              _c("th", { attrs: { width: "50px" } }),
              _vm._v(" "),
              !_vm.showExpireDates && _vm.invoiceType === "income"
                ? _c("th", { staticClass: "wrap", attrs: { width: "50" } }, [
                    _vm._v("\n        Другая валюта\n      "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("th", { staticClass: "drug_field" }, [
                _vm._v("Препарат "),
                _c(
                  "span",
                  {
                    staticClass: "badge badge-info badge_sort",
                    on: { click: _vm.changeSort },
                  },
                  [
                    _vm._v("по " + _vm._s(_vm.sortText[_vm.currentSort]) + " "),
                    _c("i", { staticClass: "icon-fa icon-fa-sort-desc" }),
                  ]
                ),
              ]),
              _vm._v(" "),
              !_vm.showExpireDates ? _c("th") : _vm._e(),
              _vm._v(" "),
              _c("th", { attrs: { width: "100px" } }, [_vm._v("Количество")]),
              _vm._v(" "),
              _c("th"),
              _vm._v(" "),
              _vm.invoiceType !== "income" && _vm.invoiceType !== "order"
                ? _c("th", [_vm._v("Себест.")])
                : _vm._e(),
              _vm._v(" "),
              _vm.invoiceType !== "income" && _vm.invoiceType !== "order"
                ? _c("th", [_vm._v("Сумма")])
                : _vm._e(),
              _vm._v(" "),
              _vm.invoiceType === "income" || _vm.invoiceType === "order"
                ? _c("th", [_vm._v("Стоимость")])
                : _vm._e(),
              _vm._v(" "),
              !_vm.showExpireDates
                ? [
                    _vm.invoiceType === "income" || _vm.invoiceType === "order"
                      ? _c("th", [_vm._v("Сумма без скидки")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.invoiceType === "income" || _vm.invoiceType === "order"
                      ? _c("th", [_vm._v("Стоимость со скидкой")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.invoiceType === "income" || _vm.invoiceType === "order"
                      ? _c("th", [_vm._v("Сумма со скидкой")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.invoiceType === "transit"
                      ? _c("th", [
                          _c("div", [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm._v("Наличие"),
                            ]),
                            _vm._v(" "),
                            _vm.invoice.status === 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "text-muted",
                                    staticStyle: {
                                      "font-size": "8px",
                                      "text-transform": "none",
                                    },
                                  },
                                  [_vm._v("без учета тек инвойса")]
                                )
                              : _vm._e(),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.invoiceType !== "income" && _vm.invoiceType !== "order"
                      ? _c("th", [_vm._v("Склад")])
                      : _vm._e(),
                  ]
                : [
                    _c("th", [_vm._v("до пост.")]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { "min-width": "470px" } }, [
                      _vm._v("Срок годности"),
                    ]),
                  ],
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.detailList, function (detail, index) {
            return _c(
              "tr",
              { key: index, class: { detail_error: detail.error } },
              [
                _c("td", [_vm._v(_vm._s(index + 1))]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    detail.drug
                      ? [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-default comments_btn",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.openCommentBlock(detail)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "icon-fa icon-fa-comments-o text-center",
                              }),
                              _vm._v(" "),
                              detail.comments && detail.comments.length
                                ? _c(
                                    "span",
                                    { staticClass: "badge badge-info" },
                                    [_vm._v(_vm._s(detail.comments.length))]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.showExpireDates && _vm.invoiceType === "income"
                  ? _c("td", [
                      _c("div", { staticClass: "flex v-align-center" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: detail.anotherCurrency,
                              expression: "detail.anotherCurrency",
                            },
                          ],
                          attrs: {
                            disabled:
                              detail.edit === undefined ? false : !detail.edit,
                            type: "checkbox",
                          },
                          domProps: {
                            checked: Array.isArray(detail.anotherCurrency)
                              ? _vm._i(detail.anotherCurrency, null) > -1
                              : detail.anotherCurrency,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = detail.anotherCurrency,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        detail,
                                        "anotherCurrency",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        detail,
                                        "anotherCurrency",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(detail, "anotherCurrency", $$c)
                                }
                              },
                              function ($event) {
                                return _vm.clearDrug(
                                  detail.drug ? detail.drug.id : null
                                )
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        detail.drug &&
                        detail.anotherCurrency &&
                        detail.drug.currency !== _vm.invoice.currency_alias
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-xs m-l-5",
                                on: {
                                  click: function ($event) {
                                    return _vm.changingCurrency(detail.drug)
                                  },
                                },
                              },
                              [_vm._v("сменить\n          ")]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _vm.disableEdit && detail.drug
                      ? [
                          _vm._v(
                            "\n          " +
                              _vm._s(detail.drug.title) +
                              "\n        "
                          ),
                        ]
                      : [
                          _c("DrugSearchNew", {
                            ref: `search_drug_${index}`,
                            refInFor: true,
                            attrs: {
                              selectedDrug: detail.drug,
                              onSelect: (d) => _vm.addDrug(index, d),
                              storeIdRequest: _vm.invoice.store_out,
                            },
                          }),
                        ],
                    _vm._v(" "),
                    _c("div", { staticClass: "drug_info_block" }, [
                      detail.drug &&
                      detail.drug.pack_set &&
                      +detail.drug.pack_set !== 1
                        ? _c("p", [
                            _vm._v("Препарат комплектный: "),
                            _c("span", { staticClass: "badge badge-info" }, [
                              _vm._v("1 комплект"),
                            ]),
                            _vm._v(" -\n            "),
                            _c("strong", [
                              _vm._v(_vm._s(detail.drug.pack_set)),
                            ]),
                            _vm._v("\n            (зав.уп.)"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      detail.drug && detail.drug.cool
                        ? _c("p", [
                            _c("span", { staticClass: "icon icon-snowflake" }),
                            _vm._v(" необходим хладоген"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      detail.drug && detail.drug.pack_comment
                        ? _c("p", { staticClass: "pack_comment" }, [
                            _vm._v(_vm._s(detail.drug.pack_comment)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      detail.drug && detail.drug.pack_box_comment
                        ? _c("p", { staticClass: "pack_box_comment" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(detail.drug.pack_box_comment)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.showExpireDates
                  ? _c("td", [
                      !_vm.disableEdit &&
                      (detail.edit === undefined ? false : !detail.edit)
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-success",
                              on: {
                                click: function ($event) {
                                  detail.edit = !detail.edit
                                },
                              },
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-edit" })]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("td", [
                  detail.drug
                    ? _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|max_value:500|max:500|min:1",
                              expression:
                                "'required|max_value:500|max:500|min:1'",
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: detail.qty,
                              expression: "detail.qty",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            name: `req_qty_${detail.drug.id}`,
                            disabled:
                              detail.edit === undefined ? false : !detail.edit,
                            placeholder: "Кол. упаковок",
                            "data-vv-as": "Кол. упаковок",
                          },
                          domProps: { value: detail.qty },
                          on: {
                            change: () =>
                              _vm.updateDiscountData(detail.drug.id),
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(detail, "qty", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.errors.has(`req_qty_${detail.drug.id}`)
                          ? _c(
                              "small",
                              { staticClass: "form-text text-danger" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.errors.first(
                                        `req_qty_${detail.drug.id}`
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        detail.drug.pack_set && detail.drug.pack_set != 1
                          ? _c("p", [_vm._v("зав.уп.")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.invoiceType === "order" && detail.drug.detail
                          ? _c("p", { staticClass: "badge badge-info" }, [
                              _vm._v("по коэффициенту\n            "),
                              _c("strong", [
                                _vm._v(_vm._s(detail.drug.detail.int_value)),
                              ]),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "comments_block" },
                  [
                    detail.comments
                      ? [
                          _c(
                            "v-popover",
                            { attrs: { placement: "left", trigger: "hover" } },
                            [
                              _c("i", { staticClass: "icon-fa icon-fa-info" }),
                              _vm._v(" "),
                              _c("template", { slot: "popover" }, [
                                _c(
                                  "div",
                                  _vm._l(detail.comments, function (comment) {
                                    return _c(
                                      "div",
                                      { staticClass: "mb-1 comment_div" },
                                      [
                                        _c("p", [_vm._v(_vm._s(comment.text))]),
                                        _vm._v(" "),
                                        comment.changes &&
                                        +comment.changes.old_qty !==
                                          +comment.changes.new_qty
                                          ? _c("p", [
                                              _vm._v(
                                                "\n                    смена количества "
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    +comment.changes.old_qty
                                                  )
                                                ),
                                              ]),
                                              _vm._v(
                                                " =>\n                    "
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    +comment.changes.new_qty
                                                  )
                                                ),
                                              ]),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-muted text-right",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(comment.user_name) +
                                                " (" +
                                                _vm._s(
                                                  _vm.printDate(comment.date)
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]),
                            ],
                            2
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.showExpireDates
                  ? [
                      _vm.invoiceType === "income" ||
                      _vm.invoiceType === "order"
                        ? _c("td", [
                            detail.drug
                              ? _c("div", { staticClass: "discount_data" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: detail.income_price,
                                        expression: "detail.income_price",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "number",
                                      name: `req_price_${detail.drug.id}`,
                                      disabled:
                                        detail.edit === undefined
                                          ? false
                                          : !detail.edit,
                                      placeholder: "Стоимость",
                                      "data-vv-as": "Стоимость",
                                    },
                                    domProps: { value: detail.income_price },
                                    on: {
                                      change: _vm.updateDiscountData,
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          detail,
                                          "income_price",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.errors.has(`req_price_${detail.drug.id}`)
                                    ? _c(
                                        "small",
                                        {
                                          staticClass: "form-text text-danger",
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  `req_price_${detail.drug.id}`
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invoiceType !== "income" &&
                      _vm.invoiceType !== "order"
                        ? _c(
                            "td",
                            [
                              detail &&
                              detail.drug &&
                              _vm.loadingCostPrice[detail.drug.id]
                                ? [
                                    _c("clip-loader", {
                                      attrs: {
                                        loading: true,
                                        color: _vm.$constants.LOADING_COLOR,
                                        size: "20px",
                                      },
                                    }),
                                  ]
                                : [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(detail.cost_price) +
                                        "\n          "
                                    ),
                                  ],
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", [
                        detail.drug
                          ? _c("span", [_vm._v(_vm._s(_vm.printSum(detail)))])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.invoiceType === "income" ||
                      _vm.invoiceType === "order"
                        ? _c("td", [
                            _c("div", {
                              staticClass: "discount_div",
                              domProps: {
                                innerHTML: _vm._s(_vm.printDiscount(detail)),
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invoiceType === "income" ||
                      _vm.invoiceType === "order"
                        ? _c(
                            "td",
                            { class: { total_drug_sum: detail.drug } },
                            [
                              detail.drug
                                ? [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          (
                                            +detail.clearedDiscountPrice *
                                            +detail.qty
                                          ).toFixed(3)
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invoiceType === "transit"
                        ? _c(
                            "td",
                            {
                              class:
                                "text-center " +
                                (_vm.storeData[detail.drug_id]
                                  ? +_vm.storeData[detail.drug_id] >= 0
                                    ? "green_store"
                                    : "red_store"
                                  : ""),
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    +(
                                      (_vm.storeData &&
                                        _vm.storeData[detail.drug_id]) ||
                                      (detail.drug &&
                                        detail.drug.in_store &&
                                        detail.drug.in_store.qty) ||
                                      0
                                    )
                                    // + +(detail.qty || 0)
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : [
                      _c("td", [
                        _vm.expireDatesData &&
                        _vm.isStoresData &&
                        Object.keys(_vm.isStoresData).length
                          ? _c("div", { staticClass: "text-center" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.printInStore(detail)) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm.expireDatesData
                          ? _c(
                              "div",
                              [
                                _c("expireDateManage", {
                                  ref: "expireDateManage",
                                  refInFor: true,
                                  attrs: {
                                    drugId: detail.drug_id,
                                    dates: _vm.expireDatesData[detail.drug_id],
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ],
              ],
              2
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("tfoot", [
          _c("tr", [
            _c(
              "th",
              {
                staticClass: "text-right bg-info pr-5",
                attrs: { colspan: "30" },
              },
              [
                _vm._v(
                  "\n        На сумму: " +
                    _vm._s(
                      _vm.invoice.currency_id
                        ? _vm.$AllCurrencies[_vm.invoice.currency_id] &&
                            _vm.$AllCurrencies[_vm.invoice.currency_id].currency
                        : "EUR"
                    ) +
                    " "
                ),
                _c("strong", [_vm._v(_vm._s(_vm.printSum(false)))]),
                _vm._v(" "),
                _vm.invoice.currency_id && _vm.invoice.currency_id !== 28
                  ? _c("span", [
                      _vm._v("(EUR: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            Math.round(
                              +_vm.printSum(false) *
                                _vm.invoice.actual_rate *
                                100
                            ) / 100
                          )
                        ),
                      ]),
                      _vm._v(")"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                [_c("span", [_vm._v(_vm._s(_vm.printTotalDrugQty()))])],
              ],
              2
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.detailList &&
      (_vm.invoiceType === "income" || _vm.invoiceType === "order")
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.invoice.discount,
                        expression: "invoice.discount",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number" },
                    domProps: { value: _vm.invoice.discount },
                    on: {
                      change: _vm.updateDiscount,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.invoice, "discount", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "custom-control custom-radio" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.invoice.discount_type,
                          expression: "invoice.discount_type",
                        },
                      ],
                      staticClass: "custom-control-input",
                      attrs: { type: "radio", id: "customRadio1", value: "2" },
                      domProps: {
                        checked: _vm._q(_vm.invoice.discount_type, "2"),
                      },
                      on: {
                        change: [
                          function ($event) {
                            return _vm.$set(_vm.invoice, "discount_type", "2")
                          },
                          _vm.updateDiscount,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "custom-control-label",
                        attrs: { for: "customRadio1" },
                      },
                      [
                        _vm._v(
                          "Общая сумма в валюте накладной (скидка\n              "
                        ),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.discountInPercent) + "%"),
                        ]),
                        _vm._v(")"),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-control custom-radio" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.invoice.discount_type,
                          expression: "invoice.discount_type",
                        },
                      ],
                      staticClass: "custom-control-input",
                      attrs: { type: "radio", id: "customRadio2", value: "1" },
                      domProps: {
                        checked: _vm._q(_vm.invoice.discount_type, "1"),
                      },
                      on: {
                        change: [
                          function ($event) {
                            return _vm.$set(_vm.invoice, "discount_type", "1")
                          },
                          _vm.updateDiscount,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "custom-control-label",
                        attrs: { for: "customRadio2" },
                      },
                      [_vm._v("Процент с каждой позиции")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("p", [
                    _vm._v("Общая сумма накладной без скидки: "),
                    _c("strong", [_vm._v(_vm._s(_vm.printTotalSum()))]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Общая сумма накладной со скидкой: "),
                    _c("strong", [_vm._v(_vm._s(_vm.printTotalSum(true)))]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.invoice.discount
                ? _c("div", { staticClass: "col-md-3" }, [
                    _c("p", [
                      _vm._v("Реальная скидка: "),
                      _c("strong", [_vm._v(_vm._s(_vm.realDiscount))]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Реальный %: "),
                      _c("strong", [_vm._v(_vm._s(_vm.realDiscountInPercent))]),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [_c("hr")])
  },
]
render._withStripped = true

export { render, staticRenderFns }